import { excel } from "utils"
import type { ItemBuildReportRow } from "../types/itemBuildReport"
import {
  buildItemBuildExportExcelRows,
  ITEM_BUILD_EXPORT_COLUMNS,
} from "../utils/itemBuildExportData"

type ExportExcelItemBuildReportProps = {
  data: ItemBuildReportRow[]
  periodLabel: string
  module?: string
  title: string
  fileName: string
}

export function ExportExcelItemBuildReport({
  data,
  periodLabel,
  module = "INVENTORY",
  title,
  fileName,
}: ExportExcelItemBuildReportProps) {
  excel({
    dataList: buildItemBuildExportExcelRows(data),
    column: [...ITEM_BUILD_EXPORT_COLUMNS],
    module,
    title,
    fileName,
    date: periodLabel,
  })
}
